import { SVGProps } from "react";

export const RollbackCircleSVG = ({
  color,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke={color} strokeWidth={1.2} />
    <path
      d="M12.2877 5.34945C11.3982 5.32405 10.5127 5.47732 9.68344 5.80019C8.85423 6.12306 8.09819 6.60897 7.46007 7.22917C6.82195 7.84937 6.31471 8.59126 5.96837 9.41095C5.62202 10.2306 5.4436 11.1115 5.44367 12.0013H4.12068C3.78809 12.0013 3.62549 12.4004 3.862 12.6296L5.92408 14.699C6.0719 14.8469 6.30102 14.8469 6.44884 14.699L8.51092 12.6296C8.74743 12.4004 8.57744 12.0013 8.25224 12.0013H6.92186C6.92186 9.11885 9.27219 6.79069 12.1695 6.82765C14.9189 6.8646 17.2323 9.17798 17.2692 11.9274C17.3062 14.8173 14.978 17.175 12.0955 17.175C10.9056 17.175 9.80434 16.7685 8.93221 16.0811C8.79064 15.9696 8.61303 15.914 8.43314 15.9249C8.25326 15.9358 8.08366 16.0125 7.9566 16.1403C7.64618 16.4581 7.66835 16.9755 8.01573 17.2489C9.17996 18.1608 10.6167 18.6553 12.0955 18.6532C15.828 18.6532 18.8509 15.5712 18.7474 11.8092C18.6513 8.3428 15.7541 5.44554 12.2877 5.34945Z"
      fill={color}
    />
  </svg>
);
